import * as actionTypes from './types';
import { request } from '../../request/index';
import storePersist from '../storePersist';
 
export const queryByStore = {
    resetState:
        (props = {}) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.QUERY_BY_STORE_RESET_STATE,
                });
            },
    resetAction:
        ({ actionType }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.QUERY_BY_STORE_RESET_ACTION,
                    keyState: actionType,
                    payload: null,
                });
            },
    currentItem:
        ({ data }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.QUERY_BY_STORE_CURRENT_ITEM,
                    payload: { ...data },
                });
            },
    currentAction:
        ({ actionType, data }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.QUERY_BY_STORE_CURRENT_ACTION,
                    keyState: actionType,
                    payload: { ...data },
                });
            },
            list:
            ({url, entity, jsonData, options }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.QUERY_BY_STORE_REQUEST_LOADING,
                    keyState: 'list',
                    payload: null,
                });
 
                let data = await request.list({url, entity, jsonData, options });
                if (data.status === 200) {
                    storePersist.set('queryByStore', {
                        current: data.data.Records,
                        isLoading: false,
                        isSuccess: true,
                    })
                    const result = {
                        items: data.data.Records,
                        // pagination:
                        // {
                        //     current: parseInt(data.pagination.page, 10),
                        //     pageSize: parseInt(data.pagination.pages, 10),
                        //     showSizeChanger: false,
                        //     total: parseInt(data.pagination.count, 10),
                        // },
                    };
                    dispatch({
                        type: actionTypes.QUERY_BY_STORE_REQUEST_SUCCESS,
                        keyState: 'list',
                        payload: result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.QUERY_BY_STORE_REQUEST_FAILED,
                        keyState: 'list',
                        payload: null,
                    });
                }
            },
            
    // filter:
    //     ({ entity, options = { page: 1 } }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.QUERY_BY_STORE_REQUEST_LOADING,
    //                 keyState: 'filter',
    //                 payload: null,
    //             });
 
    //             let data = await request.filter({ entity, options });
 
    //             if (data.success === true) {
    //                 const result = {
    //                     items: data.result,
    //                     pagination: {
    //                         current: parseInt(data.pagination.page, 10),
    //                         pageSize: 10,
    //                         showSizeChanger: false,
    //                         total: parseInt(data.pagination.count, 10),
    //                     },
    //                 };
    //                 dispatch({
    //                     type: actionTypes.QUERY_BY_STORE_REQUEST_SUCCESS,
    //                     keyState: 'filter',
    //                     payload: result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.QUERY_BY_STORE_REQUEST_FAILED,
    //                     keyState: 'filter',
    //                     payload: null,
    //                 });
    //             }
    //         },
    // count:
    //     ({ entity, options = { page: 1 } }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.QUERY_BY_STORE_REQUEST_LOADING,
    //                 keyState: 'count',
    //                 payload: null,
    //             });
 
    //             let data = await request.count({ entity, options });
 
    //             if (data.success === true) {
    //                 const result = {
    //                     items: data.result,
    //                     pagination: {
    //                         current: parseInt(data.pagination.page, 10),
    //                         pageSize: 10,
    //                         showSizeChanger: false,
    //                         total: parseInt(data.pagination.count, 10),
    //                     },
    //                 };
    //                 dispatch({
    //                     type: actionTypes.QUERY_BY_STORE_REQUEST_SUCCESS,
    //                     keyState: 'count',
    //                     payload: result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.QUERY_BY_STORE_REQUEST_FAILED,
    //                     keyState: 'list',
    //                     payload: null,
    //                 });
    //             }
    //         },
   
 
    // search:
    //     ({ entity, options = {} }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.QUERY_BY_STORE_REQUEST_LOADING,
    //                 keyState: 'search',
    //                 payload: null,
    //             });
 
    //             let data = await request.search({ entity, options });
 
    //             if (data.success === true) {
    //                 dispatch({
    //                     type: actionTypes.QUERY_BY_STORE_REQUEST_SUCCESS,
    //                     keyState: 'search',
    //                     payload: data.result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.QUERY_BY_STORE_REQUEST_FAILED,
    //                     keyState: 'search',
    //                     payload: null,
    //                 });
    //             }
    //         },
};